import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Analytics } from "@vercel/analytics/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "./components/ErrorBoundary";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Projects from "./pages/Projects";
import McpJestCaseStudy from "./pages/lab/McpJestCaseStudy";
import HundredLinesStudy from "./pages/lab/HundredLinesStudy";
import FoundingEngineerStudy from "./pages/lab/FoundingEngineerStudy";
import OmniMcpStudy from "./pages/lab/OmniMcpStudy";
import AITerminalCourseStudy from "./pages/lab/AITerminalCourseStudy";
import UnengineeredStudy from "./pages/lab/UnengineeredStudy";
import OpenSourcePlaybookStudy from "./pages/lab/OpenSourcePlaybookStudy";
import AbstractionStackStudy from "./pages/lab/AbstractionStackStudy";
import MeetingTaxStudy from "./pages/lab/MeetingTaxStudy";
import InterviewParadoxStudy from "./pages/lab/InterviewParadoxStudy";
import KeyboardJourneyStudy from "./pages/lab/KeyboardJourneyStudy";
import AttentionResidueStudy from "./pages/lab/AttentionResidueStudy";
import LearningAIStudy from "./pages/lab/LearningAIStudy";
import Labs from "./pages/Labs";
import Now from "./pages/Now";
import AlgorithmView from "./pages/AlgorithmView";
import Connected from "./pages/Connected";
import LinkedInWrapped from "./pages/LinkedInWrapped";
import Friday from "./pages/Friday";
import AI from "./pages/AI";

const queryClient = new QueryClient();

const App = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <Analytics />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/now" element={<Now />} />
            <Route path="/labs" element={<Labs />} />
            <Route path="/algorithm" element={<AlgorithmView />} />
            <Route path="/connected" element={<Connected />} />
            <Route path="/wrapped" element={<LinkedInWrapped />} />
            <Route path="/lab/mcp-jest" element={<McpJestCaseStudy />} />
            <Route path="/lab/100-lines" element={<HundredLinesStudy />} />
            <Route path="/lab/founding-engineer" element={<FoundingEngineerStudy />} />
            <Route path="/lab/omnimcp" element={<OmniMcpStudy />} />
            <Route path="/lab/ai-terminal-course" element={<AITerminalCourseStudy />} />
            <Route path="/lab/unengineered" element={<UnengineeredStudy />} />
            <Route path="/lab/open-source-playbook" element={<OpenSourcePlaybookStudy />} />
            <Route path="/lab/abstraction-stack" element={<AbstractionStackStudy />} />
            <Route path="/lab/meeting-tax" element={<MeetingTaxStudy />} />
            <Route path="/lab/interview-paradox" element={<InterviewParadoxStudy />} />
            <Route path="/lab/keyboard-journey" element={<KeyboardJourneyStudy />} />
            <Route path="/lab/attention-residue" element={<AttentionResidueStudy />} />
            <Route path="/lab/learning-ai" element={<LearningAIStudy />} />
            <Route path="/friday" element={<Friday />} />
            <Route path="/ai" element={<AI />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
};

export default App;